import { Switch, SwitchProps } from "antd";
import styles from "./index.module.css";
import { RefAttributes } from "react";

export const CustomSwitcher = (props: SwitchProps & RefAttributes<HTMLButtonElement>) => {
  return <Switch {...props} className={props.className ? `${props.className} ${styles.wrapper}` : styles.wrapper} />;
};
